import { createBrowserRouter } from 'react-router-dom'
import React, { Suspense } from 'react'
import { AuthLayout } from '@/app/layouts'
import WrapperLayout from '@/app/layouts/wrapper-layout'
import { SpinnerLoader } from '@/shared/ui/SpinnerLoader'
const MainPage = () => import('@/app/pages/main')
const LoginPage = () => import('@/app/pages/auth/login')
const AdminPage = () => import('@/app/pages/admin')
const SummariesPage = () => import('@/app/pages/admin/summaries')
const EarningsPage = () => import('@/app/pages/admin/earnings')
const PayoutsPage = () => import('@/app/pages/admin/payouts')
const EarningOptionsPage = () => import('@/app/pages/admin/earning-options')
const UsersPage = () => import('@/app/pages/admin/users')
const UserEarningOptionsPage = () => import('@/app/pages/admin/user-earning-options')

const SuspenseWrapper = (callback: () => any) => {
    const LazyElement = React.lazy(callback)

    return (
        <Suspense fallback={<SpinnerLoader />}>
            <LazyElement />
        </Suspense>
    )
}

const router = createBrowserRouter([
    {
        path: '',
        element: <WrapperLayout />,
        children: [
            {
                path: '/',
                element: SuspenseWrapper(MainPage),
            },
            {
                path: '/auth',
                element: <AuthLayout />,
                children: [
                    {
                        path: 'login',
                        element: SuspenseWrapper(LoginPage),
                    },
                ],
            },
            {
                path: 'admin',
                element: SuspenseWrapper(AdminPage),
                children: [
                    {
                        path: '',
                        element: SuspenseWrapper(SummariesPage),
                    },
                    {
                        path: 'summaries',
                        element: SuspenseWrapper(SummariesPage),
                    },
                    {
                        path: 'earnings',
                        element: SuspenseWrapper(EarningsPage),
                    },
                    {
                        path: 'payouts',
                        element: SuspenseWrapper(PayoutsPage),
                    },
                    {
                        path: 'earning-options',
                        element: SuspenseWrapper(EarningOptionsPage),
                    },
                    {
                        path: 'users',
                        element: SuspenseWrapper(UsersPage),
                    },
                    {
                        path: 'users/:userId',
                        element: SuspenseWrapper(UserEarningOptionsPage),
                    },
                ],
            },
        ],
    },
])
export { router }
